import ApiService from "../ApiService";

const DetailsService = {
    loadScreenView: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/promotion/share/loadpromotion", { vo }, successCallback, failureCallback);
    },

    isAttendPromotion: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/promotion/share/isattendpromotion", { ...vo }, successCallback, failureCallback);
    },
    GetWechatOfficialAccountSignature: (vo, successCallback, failureCallback) => {
        ApiService.post("web/admin/promotion/management/details/getwechatofficialaccountsignature", vo, successCallback, failureCallback);
    },

    loadPromotionForStudent: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/promotion/share/loadpromotionforstudent", { vo }, successCallback, failureCallback);
    },
};

export default DetailsService;
